function Terms() {
  return (
    <div className="animate-fade-in mx-auto max-w-4xl py-12">
      <h1 className="gradient-text mb-4 text-4xl font-bold">
        Terms of Service
      </h1>

      <p className="mb-2 text-gray-600">
        By using Xhalin, you agree to these terms. Please read them carefully so
        you know what to expect and what your responsibilities are while using
        the platform.
      </p>
      <p className="mb-6 text-sm text-gray-500">Last updated: November 2025</p>

      <div className="space-y-6">
        <section className="card">
          <h2 className="mb-3 text-2xl font-semibold">
            1. Acceptance of Terms
          </h2>
          <p className="text-gray-700">
            By accessing or using Xhalin, you agree to be bound by these Terms
            of Service and our Privacy Policy. If you do not agree, please stop
            using the service.
          </p>
        </section>

        <section className="card">
          <h2 className="mb-3 text-2xl font-semibold">2. Eligibility</h2>
          <p className="text-gray-700">
            You must be at least 13 years old to use Xhalin. By using the
            service, you confirm that you meet this requirement.
          </p>
        </section>

        <section className="card">
          <h2 className="mb-3 text-2xl font-semibold">3. Your Account</h2>
          <p className="text-gray-700">
            You are responsible for keeping your login information secure. Any
            activity under your account is your responsibility. If you suspect
            unauthorized access, please contact us immediately.
          </p>
        </section>

        <section className="card">
          <h2 className="mb-3 text-2xl font-semibold">4. Use of the Service</h2>
          <p className="text-gray-700">
            You agree not to misuse Xhalin. This includes:
          </p>
          <ul className="list-inside list-disc text-gray-700">
            <li>Attempting to hack, disrupt, or damage the platform</li>
            <li>
              Using automated tools to manipulate sessions or leaderboards
            </li>
            <li>Interfering with other users or the service infrastructure</li>
            <li>Uploading harmful content or engaging in abusive behavior</li>
          </ul>
          <p className="mt-2 text-gray-700">
            We may suspend or terminate accounts that violate these rules.
          </p>
        </section>

        <section className="card">
          <h2 className="mb-3 text-2xl font-semibold">
            5. Leaderboard and Public Content
          </h2>
          <p className="text-gray-700">
            If you choose to save sessions publicly, your username and
            statistics may appear on the global leaderboard. You control whether
            your sessions are public or private.
          </p>
        </section>

        <section className="card">
          <h2 className="mb-3 text-2xl font-semibold">
            6. Intellectual Property
          </h2>
          <p className="text-gray-700">
            Xhalin, including its design, branding, features, and content, is
            owned by us. You may not copy, distribute, or reverse-engineer any
            part of the service without permission.
          </p>
        </section>

        <section className="card">
          <h2 className="mb-3 text-2xl font-semibold">
            7. Third-Party Services
          </h2>
          <p className="text-gray-700">
            Xhalin may integrate with third-party services such as Supabase and
            analytics providers. We are not responsible for the content,
            policies, or performance of those external services.
          </p>
        </section>

        <section className="card">
          <h2 className="mb-3 text-2xl font-semibold">8. Health Disclaimer</h2>
          <p className="text-gray-700">
            Xhalin is a guided breathing platform meant for general wellness. It
            is not medical advice. If you have health concerns, respiratory
            issues, or conditions affecting your ability to perform breathing
            exercises, consult a medical professional before using the app.
          </p>
        </section>

        <section className="card">
          <h2 className="mb-3 text-2xl font-semibold">
            9. Service Availability
          </h2>
          <p className="text-gray-700">
            We strive to keep Xhalin available at all times, but we cannot
            guarantee uninterrupted access. Maintenance, updates, outages, or
            technical issues may affect availability.
          </p>
        </section>

        <section className="card">
          <h2 className="mb-3 text-2xl font-semibold">
            10. Limitation of Liability
          </h2>
          <p className="text-gray-700">
            Xhalin is provided “as is.” We are not liable for any damages, data
            loss, or issues that may arise from using the service. Your use of
            the platform is at your own risk.
          </p>
        </section>

        <section className="card">
          <h2 className="mb-3 text-2xl font-semibold">11. Termination</h2>
          <p className="text-gray-700">
            You may delete your account at any time. We may suspend or terminate
            your access if you violate these terms or misuse the platform.
          </p>
        </section>

        <section className="card">
          <h2 className="mb-3 text-2xl font-semibold">
            12. Changes to These Terms
          </h2>
          <p className="text-gray-700">
            We may update these Terms of Service from time to time. If changes
            are significant, we will notify users. The latest version will
            always be posted on this page.
          </p>
        </section>

        <section className="card">
          <h2 className="mb-3 text-2xl font-semibold">13. Contact Us</h2>
          <p className="text-gray-700">
            If you have any questions or concerns about these terms, reach us at{' '}
            <strong>support@xhalin.com</strong>.
          </p>
        </section>
      </div>
    </div>
  );
}

export default Terms;
